const PERSIAN_DIGITS = "۰۱۲۳۴۵۶۷۸۹";
const ARABIC_DIGITS = "٠١٢٣٤٥٦٧٨٩";

export function toEnglishDigits(value: string): string {
  return value.replace(/[۰-۹٠-٩]/g, (char) => {
    const persianIndex = PERSIAN_DIGITS.indexOf(char);
    if (persianIndex !== -1) return String(persianIndex);

    const arabicIndex = ARABIC_DIGITS.indexOf(char);
    if (arabicIndex !== -1) return String(arabicIndex);

    return char;
  });
}

function isPhoneLikeInput(value: string): boolean {
  const trimmed = value.trim();
  if (!trimmed) return false;

  return /^[\s+\-().۰-۹٠-٩0-9]+$/.test(trimmed);
}

export function normalizePhoneNumber(value: string): string {
  let normalized = toEnglishDigits(value.trim()).replace(/[\s\-().]/g, "");

  if (normalized.startsWith("+98")) {
    normalized = `0${normalized.slice(3)}`;
  } else if (normalized.startsWith("0098")) {
    normalized = `0${normalized.slice(4)}`;
  } else if (normalized.startsWith("98") && normalized.length === 12) {
    normalized = `0${normalized.slice(2)}`;
  } else if (/^9\d{9}$/.test(normalized)) {
    normalized = `0${normalized}`;
  }

  return normalized;
}

export function normalizeSearchInput(value: string): string {
  if (!isPhoneLikeInput(value)) {
    return value;
  }

  return normalizePhoneNumber(value);
}
